var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getPermission.do.view || _vm.getPermission.doReadOnly.view)?_c('div',[_c('md-tabs',{staticClass:"do-tab",attrs:{"md-sync-route":""}},[_c('md-tab',{attrs:{"id":"tab-do-header","md-label":"Header","to":"/do/headers"}}),_c('md-tab',{attrs:{"id":"tab-do-item","md-label":"Item","to":"/do/items"}})],1),_c('router-view')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }